module.exports = __webpack_public_path__ + "static/media/updated-file.57529b4d.svg";